module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBold.8c581f3.woff";